<style>
.van-tabs--line .van-tabs__wrap{height: 88px}
.van-tabs__wrap--scrollable .van-tab{margin:0px 10px}
.van-tabs__content--animated{background: linear-gradient( 153deg, #EBF3FD 0%, #F4F8FC 100%);box-shadow: 0px 0px 4px 1px rgba(10,63,190,0.16);border-radius: 3px;border: 1px solid #FFFFFF;}
</style>
<template>
  <div class="home">
    <!-- Header -->
    <PhoneHeader @openForm="handleMenu"></PhoneHeader>
    <div class="banner-box">
      <div class="banner-con">
        <div class="banner-title">轻骑兵<div style="font-size: 13px;vertical-align: super;line-height: 27px">®</div>统一门户平台</div>
        <div class="banner-desc">信息聚合，决策有道</div>
        <div class="app-button-div">
          <img class="app-button-img" src="../assets/img/zeroCodePhone/app-button-bg.png" @click="handleOpenPractice"/>
        </div>
        <!--一站式信息聚合与应用聚合工具-->
        <div class="div-title">核心价值</div>
        <div class="div-desc">一站式信息聚合与应用聚合工具</div>
        <div class="base-content-div">
          <div>
            <div class="base-content-title">统一入口 便捷高效</div>
            <div class="base-content-desc">通过聚合用户常用信息、待办事项、快捷入口以及应用入口等，能够直观地展示用户关心的数据，帮助用户更加高效地处理工作和任务，进一步提升工作效率。</div>
          </div>
          <div>
            <img src="../assets/img/unifiedPortalPhone/base-img1.png" style="top: -115px"/>
          </div>
        </div>
        <div class="base-content-div">
          <div>
            <div class="base-content-title">量身定制  千人千面</div>
            <div class="base-content-desc">支持采用可视化拖拉拽配置式的门户，允许用户或管理员根据需求和角色，快速且灵活地配置个性化门户，确保每位用户都能拥有符合自己工作习惯和需求的智能工作台，从而实现真正的“千人千面”体验。</div>
          </div>
          <div>
            <img src="../assets/img/unifiedPortalPhone/base-img2.png"/>
          </div>
        </div>
        <div class="base-content-div">
          <div>
            <div class="base-content-title">统一认证 统筹管理</div>
            <div class="base-content-desc">帮助企业快速打通多业务应用数据，简化繁琐的认证流程，统筹管理内部用户、外部用户以及合作伙伴用户，从而建立起一套高标准的统一认证管理体系，确保用户信息的准确性和安全性。</div>
          </div>
          <div>
            <img src="../assets/img/unifiedPortalPhone/base-img3.png"/>
          </div>
        </div>
        <div class="base-content-div">
          <div>
            <div class="base-content-title">权限管理  安全可控</div>
            <div class="base-content-desc">建立专业、统一且易用的权限管理体系，通过一站式解决方案，全面应对企业面临的权限管理问题，保护公司的数据和业务安全，杜绝越权操作隐患，确保企业信息资产的安全性和完整性。</div>
          </div>
          <div>
            <img src="../assets/img/unifiedPortalPhone/base-img4.png"/>
          </div>
        </div>
        <!--主要功能-->
        <div class="digitalize">
          <div class="div-title" style="margin-bottom: 25px">主要功能</div>
          <div class="digitalize-bg">
            <img src="../assets/img/unifiedPortalPhone/digitalize.png" />
          </div>
        </div>
        <!-- 统一门户平台 让您体验智慧办公新时代 -->
        <div class="main-method">
          <div class="div-title">统一门户平台</div>
          <div class="div-title" style="margin-top: -15px">让您体验智慧办公新时代</div>
          <div class="div-desc" style="margin-bottom: 10px">聚合信息、个性定制、千企千面</div>
          <van-tabs
            v-model="mainActive"
            animated
            swipeable
            duration="0.5"
            line-width="80px"
            line-height="2px"
            title-active-color="#186CF5"
            color="#186CF5"
            style="z-index: 5"
            swipe-threshold="4"
          >
            <van-tab name="first">
              <div slot="title" style="line-height: 15px;color: #2e2e2e;text-align: center">
                <div><img style="width: 50px" src="../assets/img/unifiedPortalPhone/tab1.png"></div>
                智能工作台
              </div>
              <div class="main-tabs-tabItem">
                <img src="../assets/img/unifiedPortal/function-box-img1.png" />
              </div>
              <div class="main-tabs-tabItem-box">
                <div class="main-tabs-tabItem-context">
                  <div class="main-tabs-tabItem-context-item">
                    <div>提供基于拖拽配置式的可视化页面，提供内部员工、合作伙伴、外部客户，全场景数字身份管理服务，打造千人千面、千企千面的智能工作台。</div>
                  </div>
                </div>
              </div>
            </van-tab>
            <van-tab name="second">
              <div slot="title" style="line-height: 15px;color: #2e2e2e;text-align: center">
                <div><img style="width: 50px" src="../assets/img/unifiedPortalPhone/tab2.png"></div>
                应用中心
              </div>
              <div class="main-tabs-tabItem">
                <img src="../assets/img/unifiedPortal/function-box-img2.png" />
              </div>
              <div class="main-tabs-tabItem-box">
                <div class="main-tabs-tabItem-context">
                  <div class="main-tabs-tabItem-context-item">
                    <div>通过应用中心实现各系统入口统一，如聚合ERP应用、CRM应用、报销审批等。</div>
                  </div>
                </div>
              </div>
            </van-tab>
            <van-tab name="third">
              <div slot="title" style="line-height: 15px;color: #2e2e2e;text-align: center">
                <div><img style="width: 50px" src="../assets/img/unifiedPortalPhone/tab3.png"></div>
                信息中心
              </div>
              <div class="main-tabs-tabItem">
                <img src="../assets/img/unifiedPortal/function-box-img3.png" />
              </div>
              <div class="main-tabs-tabItem-box">
                <div class="main-tabs-tabItem-context">
                  <div class="main-tabs-tabItem-context-item">
                    <div>聚合各种信息源，待办事项、消息提醒、通知公告和日程集中展示，高效协同办公。</div>
                  </div>
                </div>
              </div>
            </van-tab>
            <van-tab name="fourth">
              <div slot="title" style="line-height: 15px;color: #2e2e2e;text-align: center">
                <div><img style="width: 50px" src="../assets/img/unifiedPortalPhone/tab4.png"></div>
                统一认证
              </div>
              <div class="main-tabs-tabItem">
                <img src="../assets/img/unifiedPortal/function-box-img4.jpg" />
              </div>
              <div class="main-tabs-tabItem-box">
                <div class="main-tabs-tabItem-context">
                  <div class="main-tabs-tabItem-context-item">
                    <div>提供单点登录功能，仅需一次登录就能访问所有有权限的应用，提供便捷安全的访问体验。</div>
                  </div>
                </div>
              </div>
            </van-tab>
            <van-tab name="fifth">
              <div slot="title" style="line-height: 15px;color: #2e2e2e;text-align: center">
                <div><img style="width: 50px" src="../assets/img/unifiedPortalPhone/tab5.png"></div>
                统一权限
              </div>
              <div class="main-tabs-tabItem">
                <img src="../assets/img/unifiedPortal/function-box-img5.png" />
              </div>
              <div class="main-tabs-tabItem-box">
                <div class="main-tabs-tabItem-context">
                  <div class="main-tabs-tabItem-context-item">
                    <div>记录应用接口发布日志、接口运行日志等，并对接口调用情况做出统计分析，方便企业API运维管理。</div>
                  </div>
                </div>
              </div>
            </van-tab>
          </van-tabs>
        </div>
        <!-- 聚合信息、个性定制、千企千面 -->
        <div class="div-title">各类应用 一触即达</div>
        <div class="div-desc">加速企业信息化建设，助力新旧动能转换、 <br/>工业互联网等战略的实施落地</div>
        <div class="core-value">
          <div class="core-layout">
            <div class="core-content">
              <div class="core-item">
                <div>
                  <span class="value-title">信息聚合，应用聚合</span>
                  <div class="value-desc">能够高效整合企业内分散的应用和信息资源，提供便捷的统一访问入口，消除信息孤岛，助力企业实现资源共享和协同办公。</div>
                </div>
              </div>
              <div class="core-item">
                <div>
                  <span class="value-title">众多系统，单点登录</span>
                  <div class="value-desc">单点登录指的是用户登录多个系统时，无需重复输入系统地址、用户名、密码，减轻用户记忆负担，提升工作效率。</div>
                </div>
              </div>
              <div class="core-item">
                <div>
                  <span class="value-title">数据权限，精细控制</span>
                  <div class="value-desc">数据权限，通过管理组织、用户、功能等信息对权限统一设置，实现企业资源的多维度、精细化控制，杜绝越权操作隐患。。</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 底部公司信息 -->
        <CompanyInformation
          @changePracticeMenuShow="handleOpenPractice"
        ></CompanyInformation>
      </div>
      <!-- 右侧菜单 -->
      <RightMenu
        :isMenuShow="isMenuShow"
        @rightMenuShow="handleRightMenuShow"
      ></RightMenu>
      <!-- 底部立即体验弹出 -->
      <ExperienceNow
        :isPopShow="isPopShow"
        @CloseExperienceNow="handleCloseExperienceNow"
      ></ExperienceNow>
    </div>
    <PhoneFooter @handleFooter="handleOpenPractice"></PhoneFooter>
  </div>
</template>

<script>
import "swiper/swiper.min.css";
import "swiper/components/navigation/navigation.min.css";
import Swiper, { Navigation } from "swiper";
import PhoneHeader from "./include/PhoneHeader";
import PhoneFooter from "./include/PhoneFooter";
import RightMenu from "./include/RightMenu";
import CompanyInformation from "./include/CompanyInformation";
import ExperienceNow from "./include/ExperienceNow";
const function21 = require("../assets/img/homePage/function21.gif");
const function22 = require("../assets/img/homePage/function22.gif");
Swiper.use([Navigation]);
export default {
  name: "UnifiedPortalPhone",
  components: {
    PhoneFooter,
    PhoneHeader,
    CompanyInformation,
    RightMenu,
    ExperienceNow,
  },
  data() {
    return {
      isPopShow: false, // 立即体验弹窗
      isMenuShow: false, // 顶部菜单栏
      videoPlayDialogVisible: false, // 顶部视频播放弹窗
      modelActive: "formular", // tab页默认显示
      mainActive: "first", // tab页默认显示
      funcSrc: "function21", // 动图播放完毕后显示gif
    };
  },
  watch: {
    mainActive(n) {
      if (n === "second") {
        this.funcSrc = function21;
        setTimeout(() => {
          this.funcSrc = function22;
        }, 3000);
      }
    },
  },
  methods: {
    // 了解更多
    handleRouter() {
      this.$router.push("/CasePhonePage");
    },
    // 打开右侧菜单弹窗
    handleMenu() {
      this.isMenuShow = true;
    },
    // 关闭右侧菜单弹窗
    handleRightMenuShow() {
      this.isMenuShow = false;
    },
    // 打开立即体验弹窗
    handleOpenPractice() {
      this.isPopShow = true;
    },
    // 关闭立即体验弹窗
    handleCloseExperienceNow() {
      this.isPopShow = false;
    },
  },
  mounted() {},
};
</script>

<style scoped>
/* 头部 */
.banner-box {width: 100%;height: 391px;background: url("../assets/img/unifiedPortalPhone/banner-bg.png") no-repeat;background-size: 100%;margin-top: 52px;}
.banner-con {width: 100%;margin: 0 auto;padding-top: 20px;}
.banner-title {font-size: 23px;font-weight: bold;line-height: 50px;text-align: center;display: flex;justify-content: center;}
.banner-desc {display: flex;align-items: center;position: relative;font-size: 16px;font-weight: 400;justify-content: center;}
.app-button-div{width: 100%;text-align: center;margin-top: 190px}
.app-button-img{width: 120px;}

.div-title {font-size: 22px;font-weight: bold;line-height: 50px;text-align: center;display: flex;justify-content: center;color: #2e2e2e;margin-top: 35px}
.div-desc {display: flex;align-items: center;position: relative;font-size: 14px;font-weight: 400;justify-content: center;color: #8E8E8E;margin-bottom: 30px;text-align: center}

.base-content-div{width: 92%;margin: 15px auto;box-shadow: 0px 0px 10px 1px rgba(0,46,154,0.15);border-radius: 5px 5px 5px 5px;height: 150px;padding-top: 1px;}
.base-content-title{font-weight: bold;font-size: 16px;color: #014BE6;line-height: 31px; margin: 10px 0px 5px 15px;}
.base-content-desc{font-size: 13px;color: #2E2E2E;line-height: 22px;margin: 0px 15px 10px 15px;position: relative;z-index: 2}
.base-content-div img{width: 140px;position: relative; position: relative;top: -140px;left: 210px;z-index: 1;}

/* 企业数字化转型的底座 */
.digitalize {width: 100%;padding-top: 1px;}
.digitalize > img {width: 100%;margin-top: 20px;}
.digitalize-title {font-size: 25px;font-weight: bold;line-height: 30px;text-align: center;padding-top: 50px;padding-bottom: 25px;}
.digitalize-bg {text-align: center;padding: 0 18px;}
.digitalize-bg > img {width: 100%;}

/* 主要功能 */
.main-method {overflow: hidden;}
.main-title {font-size: 25px;font-weight: bold;line-height: 30px;text-align: center;padding: 44px 0 24px 0;}
.main-tabs-tabItem {display: flex;margin: 20px 0 32px 0;justify-content: center;}
.main-tabs-tabItem > img {height: 200px;}
.main-tabs-tabItem-box {display: flex;justify-content: center;height: 100%;min-height: 100px;}
.main-tabs-tabItem-box > div {width: 90%;}
.main-tabs-tabItem-context-item {display: flex;margin-bottom: 30px;}
.main-tabs-tabItem-context-item > img {height: 20px;padding-right: 10px;}
.main-tabs-tabItem-context-item > div {font-size: 15px;line-height: 30px;text-align: justify}
van-tabs__wrap,
.van-tabs__wrap scroll-view,
.van-tabs__nav,
.van-tab {
  height: 130px!important;
  background-color: white;
}

/* 各类业务无缝集成 */
.core-value {background: #FFFFFF;}
.core-title {font-size: 25px;font-weight: bold;line-height: 30px;text-align: center;padding: 40px 0 30px 0;}
.core-layout {display: flex;padding-bottom: 30px;}
.core-content {width: 90%;margin: auto;color: #FFFFFF;}
.value-title {font-size: 16px;font-weight: bold;}
.value-desc {font-size: 13px;margin-top: 15px;line-height: 23px;color: #EEEEEE;text-align: justify}
.core-item {background: #3273F3;background-image:url("../assets/img/unifiedPortalPhone/core-item-1.png");background-repeat:no-repeat;background-size: 100% 100%;height: 145px;margin-bottom: 20px;display: flex;padding: 20px 20px;border-radius: 3px;}
.core-item img{width: 110px;position: relative;left: 210px;top: -100px;}

/* 案例 */
.case {background: url("../assets/img/phoneHomePage/case-bg.png");height: 828px;}
.case-title {font-size: 25px;font-weight: bold;line-height: 56px;text-align: center;padding: 30px 0;color: white;}
.case-box {display: flex;justify-content: center;}
.case-swipe {height: 350px;}
.case-swipe >>> .van-swipe__indicators .van-swipe__indicator {background: #333333;}
.case-swipe >>> .van-swipe__indicator--active {background-color: #1989fa !important;}
.case-item {height: 100%;width: 90%;padding: 20px 20px 0 20px;background-image: linear-gradient(to bottom, #fff, #e9f0ff);border-radius: 5px;}
.van-swipe-item {display: flex;justify-content: center;}
.case-item > img {height: 55px;}
.case-item > .title {margin: 10px 0;font-size: 18px;font-weight: 600;}
.case-item > .text {font-size: 15px;font-weight: 400;line-height: 25px;}
.case-application-box {display: flex;justify-content: center;}
.case-application {width: 90%;height: 200px;padding: 20px;background: #203558;margin-top: 40px;}
.case-application .title {color: #fff;font-size: 18px;font-weight: bold;}
.case-application-items {display: flex;justify-content: space-between;}
.case-application-item > div {font-size: 15px;color: #fff;margin-bottom: 15px;}
.case > .btn {display: flex;justify-content: center;margin-top: 30px;}
</style>



// WEBPACK FOOTER //
// src/components/UnifiedPortalPhone.vue